import { useQueryParam } from 'hooks/utils/useQueryParam';

export const useTourAgencyInviteToken = () => {
  const inviteToken = useQueryParam('ta-invite-token');
  return inviteToken;
};
